import { Cart, DoctorAddress, Lineitem, OrderLineItem } from 'types';
import { CheckoutStates, OrderStepMode } from './';

export const ORDER_STEP_MODES: OrderStepMode[] = [
  {
    step: 'address',
    modes: {
      address: 'create',
      delivery: 'start',
      payment: 'start',
      confirm: 'start',
    },
  },
  {
    step: 'delivery',
    modes: {
      address: 'edit',
      delivery: 'create',
      payment: 'start',
      confirm: 'start',
    },
  },
  {
    step: 'payment',
    modes: {
      address: 'edit',
      delivery: 'edit',
      payment: 'create',
      confirm: 'start',
    },
  },
  {
    step: 'confirm',
    modes: {
      address: 'edit',
      delivery: 'edit',
      payment: 'edit',
      confirm: 'create',
    },
  },
  {
    step: 'complete',
    modes: {
      address: 'edit',
      delivery: 'edit',
      payment: 'edit',
      confirm: 'edit',
    },
  },
];

export const getOrderStepModes = (step: CheckoutStates) => {
  const stepModes = ORDER_STEP_MODES.find(orderStep => orderStep.step === step);
  return stepModes ? stepModes.modes : ORDER_STEP_MODES[0].modes;
};

export const getSelectedShippingAddress = (
  currentOrder: Cart | undefined,
  doctorAddress: DoctorAddress
) => {
  if (currentOrder) {
    const currentOrderShippingAddressId = currentOrder.shipToAddressId;

    if (currentOrderShippingAddressId) {
      const selectedShippingAddress = doctorAddress.shippingAddresses.filter(
        address => address.id === currentOrderShippingAddressId
      )[0];
      return selectedShippingAddress;
    }
  }
  return doctorAddress.defaultShippingAddress;
};

export const getSelectedBillingAddress = (
  currentOrder: Cart | undefined,
  doctorAddress: DoctorAddress
) => {
  if (currentOrder) {
    const currentOrderBillingAddressId = currentOrder.billToAddressId;
    if (currentOrderBillingAddressId) {
      const selectedBillingAddress = doctorAddress.billingAddresses.filter(
        address => address.id === currentOrderBillingAddressId
      )[0];
      return selectedBillingAddress;
    }
  }
  return doctorAddress.defaultBillingAddress;
};

export const isValidEmailAddress = (email: string) => {
  return email.match(
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
    ? true
    : false;
};

export const isCartContainsCustomizedItems = (
  lineItems: Lineitem[] | OrderLineItem[]
) => {
  return lineItems.some(lineItem => lineItem.isCustomizable);
};

export const isCartContainsItemsWithExpiration = (
  lineItems: Lineitem[] | OrderLineItem[]
) => {
  return lineItems.some(lineItem => lineItem.discontinueOn?.length > 0);
};

export const isCartContainsSubscriptionProducts = (
  lineItems: Lineitem[] | OrderLineItem[]
) => {
  return lineItems.some(lineItem => lineItem.isSubscribed);
};

export const renderMessageWithDynamicLinks = (
  message: string,
  links: Record<string, string>
) => {
  const parts = message.split(/(\{[^}]+\})/g);

  return parts.map((part, index) => {
    if (part.startsWith('{') && part.endsWith('}')) {
      const key = part.slice(1, -1);
      if (links[key]) {
        return (
          <a
            href={links[key]}
            key={index}
            target="_blank"
            rel="noopener noreferrer"
            style={{ whiteSpace: 'nowrap' }}
          >
            {key}
          </a>
        );
      }
    }
    return part;
  });
};

  export const limitExceededErrorMessage = (
    error: any,
    exceededItemsLabel: string
     ): string[] => {
      if (!error) return [];

      if (typeof error === 'string') {
        return [error];
      }

      if (Array.isArray(error)) {
        return error.map(
         (item: {
          name: string;
          max_quantity: number;
          requested_quantity: number;
          }) =>
            `${exceededItemsLabel} ${item.name} (Max: ${item.max_quantity}, Requested: ${item.requested_quantity})`
          );
      }

      return []; 
     };
